import React from 'react';

import DonutBase from '../DonutBase/DonutBase';

export const DonutChart = ({
    data,
    dataKey,
    centerTitle,
    centerCount,
    className,
    size,
    innerRadius,
    startAngle,
    endAngle,
    legendTitle,
    legendBackground,
    legendFormatter,
    hideLegend,
    ...props
  }) => (
    <div className={`DonutChart ${className ? className : ''}`} {...props}>
      <DonutBase
        size={size}
        data={data}
        dataKey={dataKey}
        centerTitle={centerTitle}
        centerCount={centerCount}
        legendTitle={legendTitle}
        innerRadius={innerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        hideLegend={hideLegend}
        legendBackground={legendBackground}
        legendFormatter={legendFormatter}
      />
    </div>
  );

export default DonutChart